/* eslint-disable no-unused-vars */
import store from '@/store';
const THREE = window.THREE;
import { ForgeInspection, ForgeEquipment, ForgeSettings, ForgeTagShortInfo, ForgeStructural, ForgePipeline, ForgeScaffold, ForgeAnnotation } from './../../scripts/js/forgeModels';
import { forgeFetch, postDataAsync } from './../../utils/mongoUtils';
import HttpService from './../../utils/httpService';

export const TAGS = {
    state: {
        editingTag: null,
        addingTagInfo: null,
        isTagReadOnly: true,
        previousTags: [],
        tagsActivities: {
            byActivityNumber: {},
            byTagId: {}
        },
        linkedTagsPopupCallback: null,
        tagDynamicGraphs: null,
        documentsPanelCallback: null,

        ignoredTagsIds: [],
        mutableIgnoredTagsIds: [],
        tagHarvesterInfo: {
            id: 0,
            title: "",
            filterOptions: [],
            markIgnore: false,
            removeSlash: false,
            selectedTreeLevel: "All Tiers",
            matchingCategory: "",
            matchingProperty: "",
        },

        filteredTags: [],

        // Tag Harvester
        harvesters: [],
        harvestedNodesIds: [],
        fillingHarvesterTagsThumbnails: false,
        harvesterTagsToCapture: [],

        // Structural Tags
        manualStructuralTags: [],
        structuralTags: [],
        allExistingStructuralDbIds: [],
        structuralTagsCount: 0,
        filteredStructuralTagsIds: [],        

        // Pipeline Tags
        manualPipelinesTags: [],
        pipelinesTags: [],
        allExistingPipelineDbIds: [],
        pipelinesTagsCount: 0,
        filteredPipelineTagsIds: [],
        
        //automatic tags
        automaticTags: [],
        allExistingAutomaticDbids: [],//[{id:1, dbid:254,name:xx, thumbnailUrl:xxx,objectName=xx},........]
        allAutmaticTagsCount: 0,
        filteredAutomaticTagsIds: [],
        fillingAutomaticTagsImages: false,
        selectedAutomaticTagsGroup: null,
        requestedImagesId: [],
        themedDbIds: [],
        showPopulateAutomaticTagsPopup: false,
        populateAutomaticTagsGroup: null,
        fillingInspectionsImages: false,
        inspectionDbIdsToCapture: [],

        getBaseTagsTimeout: null,

        //AMIS Tags
        amisToken: "",
        lastAMISAdvancedFetchDate: 0,
        amisSearchText: "",
        amisUnits: [],
        amisTags: [],
        inspectionTagTree: [],
        selectedInspectionTreeTag: null,
        inspectionTreeFilterChanged: new Date(),
        allAMISFilteredInspections: [], // Only filtered AMIS Inspections with available point.
        allExistingAMISDbids: [],//[{id:1,dbid:22 ,children:[],cr:1,rl:1,rt:1,pltName:xx},........]
        allAMISTagsCount: 0,
        allAMISTagsSearchCount: 0,
        isAMISTagReadOnly: true,
        editingAMISTag: null,
        showAdminSyncPopup: false,
        fillingAMISTagsImages: false,
        sortingData: [
            {
                id: 'Name',
                title: 'Tag Name',
                isSelected: true,
                isExpanded: false,
                isAsc: true,
            },
            {
                id: 'CreatedOn',
                title: 'Date Added',
                isSelected: false,
                isExpanded: false,
                isAsc: true,
            }
        ],
        InspectionRemainingLifeColorOptions: [
            {
                "code": 2,
                "codeOrdr": 6,
                "judgSymb": "F",
                "judgCor": "#ff0000",
                "judgCrr1": 8,
                "judgMkr1": "<",
                "judgCrr2": "-∞",
                "judgMkr2": ">",
                "title": "0 to 8 months"
            },
            {
                "code": 2,
                "codeOrdr": 5,
                "judgSymb": "E",
                "judgCor": "#9e3eff",
                "judgCrr1": 12,
                "judgMkr1": "<",
                "judgCrr2": 8,
                "judgMkr2": ">=",
                "title": "8 to 12 months"
            },
            {
                "code": 2,
                "codeOrdr": 4,
                "judgSymb": "D",
                "judgCor": "#ffaf60",
                "judgCrr1": 16,
                "judgMkr1": "<",
                "judgCrr2": 12,
                "judgMkr2": ">=",
                "title": "12 to 16 months"
            },
            {
                "code": 2,
                "codeOrdr": 3,
                "judgSymb": "C",
                "judgCor": "#ffff00",
                "judgCrr1": 20,
                "judgMkr1": "<",
                "judgCrr2": 16,
                "judgMkr2": ">=",
                "title": "16 to 20 months"
            },
            {
                "code": 2,
                "codeOrdr": 2,
                "judgSymb": "B",
                "judgCor": "#adff5b",
                "judgCrr1": 24,
                "judgMkr1": "<",
                "judgCrr2": 20,
                "judgMkr2": ">=",
                "title": "20 to 24 months"

            },
            {
                "code": 2,
                "codeOrdr": 1,
                "judgSymb": "A",
                "judgCor": "#ceceff",
                "judgCrr1": "∞",
                "judgMkr1": "<",
                "judgCrr2": 24,
                "judgMkr2": ">=",
                "title": "Above 24 months"
            },
            {
                "code": 2,
                "codeOrdr": 7,
                "judgSymb": 'N/A',
                "judgCor": "#0f7968",
                "judgCrr1": null,
                "judgMkr1": null,
                "judgCrr2": null,
                "judgMkr2": null,
                "title": "N/A"
            },
        ],
        InspectionThickPlanColorOptions: [
            {
                "code": 3,
                "codeOrdr": 6,
                "judgSymb": "F",
                "judgCor": "#ff0000",
                "judgCrr1": 4,
                "judgMkr1": "<",
                "judgCrr2": "-∞",
                "judgMkr2": ">",
                "title": "0 to 4 mm"
            },
            {
                "code": 3,
                "codeOrdr": 5,
                "judgSymb": "E",
                "judgCor": "#a244ff",
                "judgCrr1": 6,
                "judgMkr1": "<",
                "judgCrr2": 4,
                "judgMkr2": ">=",
                "title": "4 to 6 mm"
            },
            {
                "code": 3,
                "codeOrdr": 4,
                "judgSymb": "D",
                "judgCor": "#ffa851",
                "judgCrr1": 8,
                "judgMkr1": "<",
                "judgCrr2": 6,
                "judgMkr2": ">=",
                "title": "6 to 8 mm"
            },
            {
                "code": 3,
                "codeOrdr": 3,
                "judgSymb": "C",
                "judgCor": "#ffff00",
                "judgCrr1": 10,
                "judgMkr1": "<",
                "judgCrr2": 8,
                "judgMkr2": ">=",
                "title": "8 to 10 mm"
            },
            {
                "code": 3,
                "codeOrdr": 2,
                "judgSymb": "B",
                "judgCor": "#acff59",
                "judgCrr1": 12,
                "judgMkr1": "<",
                "judgCrr2": 10,
                "judgMkr2": ">=",
                "title": "10 to 12 mm"
            },
            {
                "code": 3,
                "codeOrdr": 1,
                "judgSymb": "A",
                "judgCor": "#ceceff",
                "judgCrr1": "∞",
                "judgMkr1": "<",
                "judgCrr2": 12,
                "judgMkr2": ">=",
                "title": "Over 12 mm"
            },
            {
                "code": 3,
                "codeOrdr": 7,
                "judgSymb": 'N/A',
                "judgCor": "#0f7968",
                "judgCrr1": null,
                "judgMkr1": null,
                "judgCrr2": null,
                "judgMkr2": null,
                "title": "N/A"
            }
        ],
        InspectionCorrRateColorOptions: [
            {
                "code": 1,
                "codeOrdr": 1,
                "judgSymb": "A",
                "judgCor": "#aaffff",
                "judgCrr1": 0.05,
                "judgMkr1": "<=",
                "judgCrr2": "-∞",
                "judgMkr2": ">",
                "title": "0 to 0.05 mm/year"
            },
            {
                "code": 1,
                "codeOrdr": 2,
                "judgSymb": "B",
                "judgCor": "#7dff7d",
                "judgCrr1": 0.1,
                "judgMkr1": "<=",
                "judgCrr2": 0.05,
                "judgMkr2": ">",
                "title": "0.05 to 0.1 mm/year"
            },
            {
                "code": 1,
                "codeOrdr": 3,
                "judgSymb": "C",
                "judgCor": "#ffff51",
                "judgCrr1": 0.2,
                "judgMkr1": "<=",
                "judgCrr2": 0.1,
                "judgMkr2": ">",
                "title": "0.1 to 0.2 mm/year"
            },
            {
                "code": 1,
                "codeOrdr": 4,
                "judgSymb": "D",
                "judgCor": "#ffa346",
                "judgCrr1": 0.4,
                "judgMkr1": "<=",
                "judgCrr2": 0.2,
                "judgMkr2": ">",
                "title": "0.2 to 0.4 mm/year"
            },
            {
                "code": 1,
                "codeOrdr": 5,
                "judgSymb": "E",
                "judgCor": "#a346ff",
                "judgCrr1": 0.8,
                "judgMkr1": "<=",
                "judgCrr2": 0.4,
                "judgMkr2": ">",
                "title": "0.4 to 0.8 mm/year"
            },
            {
                "code": 1,
                "codeOrdr": 6,
                "judgSymb": "F",
                "judgCor": "#ff0000",
                "judgCrr1": "∞",
                "judgMkr1": "<",
                "judgCrr2": 0.8,
                "judgMkr2": ">",
                "title": "Over 0.8 mm/year"
            },
            {
                "code": 1,
                "codeOrdr": 7,
                "judgSymb": 'N/A',
                "judgCor": "#0f7968",
                "judgCrr1": null,
                "judgMkr1": null,
                "judgCrr2": null,
                "judgMkr2": null,
                "title": "N/A"
            }
        ],
        LastInspectionColorOptions: [
            {
                "code": 5,
                "codeOrdr": 1,
                "judgSymb": "Less than a year",
                "judgCor": "#1153FF",
                "judgCrr1": 365,
                "judgMkr1": "<",
                "judgCrr2": 0,
                "judgMkr2": ">=",
                "title": "Less than a year"
            },
            {
                "code": 5,
                "codeOrdr": 2,
                "judgSymb": "Less than 5 years",
                "judgCor": "#65AC50",
                "judgCrr1": 1825,
                "judgMkr1": "<",
                "judgCrr2": 365,
                "judgMkr2": ">=",
                "title": "Less than 5 years"
            },
            {
                "code": 5,
                "codeOrdr": 3,
                "judgSymb": "Less than 10 years",
                "judgCor": "#f3ff00",
                "judgCrr1": 3650,
                "judgMkr1": "<",
                "judgCrr2": 1825,
                "judgMkr2": ">=",
                "title": "Less than 10 years"
            },
            {
                "code": 5,
                "codeOrdr": 4,
                "judgSymb": "Less than 15 years",
                "judgCor": "#FF5C0C",
                "judgCrr1": 5475,
                "judgMkr1": "<",
                "judgCrr2": 3650,
                "judgMkr2": ">=",
                "title": "Less than 15 years"
            },
            {
                "code": 5,
                "codeOrdr": 5,
                "judgSymb": "Over 15 years",
                "judgCor": "#ff0000",
                "judgCrr1": "∞",
                "judgMkr1": "<",
                "judgCrr2": 5475,
                "judgMkr2": ">=",
                "title": "Over 15 years"
            },
            {
                "code": 5,
                "codeOrdr": 7,
                "judgSymb": 'No Record',
                "judgCor": "#0f7968",
                "judgCrr1": null,
                "judgMkr1": null,
                "judgCrr2": null,
                "judgMkr2": null,
                "title": "No Record"
            }
        ],
        NextInspectionColorOptions: [
            {
                "code": 6,
                "codeOrdr": 1,
                "judgSymb": "Overdue",
                "judgCor": "#ff0000",
                "judgCrr1": 0,
                "judgMkr1": "<",
                "judgCrr2": "-∞",
                "judgMkr2": ">",
                "title": "Overdue"
            },
            {
                "code": 6,
                "codeOrdr": 2,
                "judgSymb": "Less than 1 year",
                "judgCor": "#FF5C0C",
                "judgCrr1": 365,
                "judgMkr1": "<",
                "judgCrr2": 0,
                "judgMkr2": ">=",
                "title": "Less than 1 year"
            },
            {
                "code": 6,
                "codeOrdr": 3,
                "judgSymb": "Less than 4 years",
                "judgCor": "#f3ff00",
                "judgCrr1": 1825,
                "judgMkr1": "<",
                "judgCrr2": 365,
                "judgMkr2": ">=",
                "title": "Less than 4 years"
            },
            {
                "code": 6,
                "codeOrdr": 4,
                "judgSymb": "Over 4 years",
                "judgCor": "#65AC50",
                "judgCrr1": "∞",
                "judgMkr1": "<",
                "judgCrr2": 1825,
                "judgMkr2": ">=",
                "title": "Over 4 years"
            },
            {
                "code": 6,
                "codeOrdr": 5,
                "judgSymb": 'No Plan',
                "judgCor": "#0f7968",
                "judgCrr1": null,
                "judgMkr1": null,
                "judgCrr2": null,
                "judgMkr2": null,
                "title": "No Plan"
            }
        ],
        InspectionPlanColorOptions: [
            {
                "code": 4,
                "codeOrdr": 1,
                "judgSymb": "Over a year",
                "judgCor": "#65AC50",
                "judgCrr1": "∞",
                "judgMkr1": "<",
                "judgCrr2": 365,
                "judgMkr2": ">=",
                "title": "Over a year"
            },
            {
                "code": 4,
                "codeOrdr": 2,
                "judgSymb": "Less than a year",
                "judgCor": "#FF5C0C",
                "judgCrr1": 365,
                "judgMkr1": "<",
                "judgCrr2": 0,
                "judgMkr2": ">=",
                "title": "Less than a year"
            },
            {
                "code": 4,
                "codeOrdr": 3,
                "judgSymb": "Overdue",
                "judgCor": "#ff0000",
                "judgCrr1": 0,
                "judgMkr1": "<",
                "judgCrr2": "-∞",
                "judgMkr2": ">",
                "title": "Overdue"
            },
            {
                "code": 4,
                "codeOrdr": 4,
                "judgSymb": 'Next Inspection date not provided',
                "judgCor": "#0f7968",
                "judgCrr1": null,
                "judgMkr1": null,
                "judgCrr2": null,
                "judgMkr2": null,
                "title": "Next Inspection date not provided"
            }
        ],
        InspectionSelectedFilter: null,
        inspectionType: 'Thickness',
        inspectionTempPresSelectedFilter: 'Temperature',
        InspectionFiltersOptions: [
            'Remaining Thickness',
            'Remaining Life',
            'Corrosion Rate',
            'Last Inspection (Thickness)',
            'Last Inspection (Visual)',
            'Last Inspection (Both)',
            'Next Inspection (Thickness)',
            'Next Inspection (Visual)',
            'Next Inspection (Both)',
            'Inspection Tag'
        ],
        inspectionMasterTypeOptions: [
            { id: 0, name: 'Select All', isChecked: true },
            { id: 1, name: 'Equipment', isChecked: true },
            { id: 2, name: 'Pipeline', isChecked: true },
            { id: 3, name: 'None', isChecked: true }
        ],
        inspectionFiltersOptionsWithCheck: [
            { name: 'Remaining Thickness', isChecked: false },
            { name: 'Last Inspection', isChecked: false, needType: true },
            { name: 'Next Inspection', isChecked: false, needType: true },
            { name: 'Remaining Life', isChecked: false, tempPresFilter: true, codeFilter: true },
            { name: 'Corrosion Rate', isChecked: false, tempPresFilter: true, codeFilter: true },
        ],
        InspectionAvailableColorOptions: [],
        selectedColorOptions: [],
        filteredInspection: [],
        isLoadingAMISTags: false,
        showTagMasterResult: false,
        isEquipmentMasterAvailable: false,
        isPipelineMasterAvailable: false,
        isStructuralMasterAvailable: false,
        isInspectionTreeOption: false,
    },

    mutations: {
        SET_EDITING_TAG(state, value) {
            state.editingTag = value;
        },
        SET_ADDING_TAG_INFO(state, value) {
            state.addingTagInfo = value;
        },
        SET_EDITING_AMIS_TAG(state, value) {
            state.editingAMISTag = value;
        },
        SET_AMIS_TAGS(state, value) {
            state.amisTags = value;
        },
        SET_IS_TAG_READ_ONLY(state, value) {
            state.isTagReadOnly = value;
        },
        SET_IS_AMIS_TAG_READ_ONLY(state, value) {
            state.isAMISTagReadOnly = value;
        },
        SET_IGNORED_TAGS_IDS(state, value) {
            state.ignoredTagsIds = value;
        },
        SET_MUTABLE_IGNORED_TAGS_IDS(state, value) {
            state.mutableIgnoredTagsIds = value;
        },
        SET_TAG_HARVESTER_INFO(state, value) {
            state.tagHarvesterInfo = value;
        },
        SET_MANUAL_STRUCTURAL_TAGS(state, value) {
            state.manualStructuralTags = value;
        },
        SET_STRUCTURAL_TAGS(state, value) {
            state.structuralTags = value;
        },
        SET_ALL_EXISTING_STRUCTURAL_TAGS(state, value) {
            state.allExistingStructuralDbIds = value;
        },
        SET_STRUCTURAL_TAGS_COUNT(state, value) {
            state.structuralTagsCount = value;
        },
        SET_FILTERED_STRUCTURAL_TAGS_IDS(state, value) {
            state.filteredStructuralTagsIds = value;
        },
        SET_MANUAL_PIPELINES_TAGS(state, value) {
            state.manualPipelinesTags = value;
        },
        SET_PIPELINES_TAGS(state, value) {
            state.pipelinesTags = value;
        },
        SET_ALL_EXISTING_PIPELINES_TAGS(state, value) {
            state.allExistingPipelineDbIds = value;
        },
        SET_PIPELINES_TAGS_COUNT(state, value) {
            state.pipelinesTagsCount = value;
        },
        SET_FILTERED_PIPELINES_TAGS_IDS(state, value) {
            state.filteredPipelineTagsIds = value;
        },
        SET_AUTOMATIC_TAGS(state, value) {
            state.automaticTags = value;
        },        
        SET_AUTOMATIC_TAGS_COUNT(state, value) {
            state.allAutmaticTagsCount = value;
        },
        SET_AMIS_TAGS_TOTAL_COUNT(state, value) {
            state.allAMISTagsCount = value;
        },
        SET_AMIS_TAGS_SEARCH_COUNT(state, value) {
            state.allAMISTagsSearchCount = value;
        },
        SET_SELECTED_AUTOMATIC_TAGS_GROUP(state, value) {
            state.selectedAutomaticTagsGroup = value;
        },
        SET_FILLING_AUTOMATIC_TAGS_IMAGES(state, value) {
            state.fillingAutomaticTagsImages = value;
        },
        SET_FILLING_HARVESTER_TAGS_THUMBNAILS(state, value) {
            state.fillingHarvesterTagsThumbnails = value;
        },
        SET_HARVESTER_TAGS_TO_CAPTURE(state, value) {
            state.harvesterTagsToCapture = value;
        },
        SET_FILLING_AMIS_TAGS_IMAGES(state, value) {
            state.fillingAMISTagsImages = value;
        },
        SET_FILLING_INSPECTIONS_IMAGES(state, value) {
            state.fillingInspectionsImages = value;
        },
        SET_INSPECTIONS_TO_CAPTURE(state, value) {
            state.inspectionDbIdsToCapture = value;
        },
        SET_LINKED_TAGS_CALLBACK(state, value) {
            state.linkedTagsPopupCallback = value;
        },
        SET_FILTERED_AUTOMATIC_TAGS_IDS(state, value) {
            state.filteredAutomaticTagsIds = value;
        },
        SET_AMIS_UNITS(state, value) {
            state.amisUnits = value;
        },
        SET_REQUESTED_IMAGES_IDS(state, value) {
            state.requestedImagesId = value
        },
        SET_AMIS_TOKEN(state, value) {
            state.amisToken = value;
        },
        SET_ALL_AMIS_FILTERED_INSPECTIONS(state, value) {
            state.allAMISFilteredInspections = value;
        },
        SET_FILTERED_INSPECTIONS(state, value) {
            state.filteredInspection = value;
        },
        SET_SHOW_POPULATE_AUTOMATIC_TAGS_POPUP(state, value) {
            state.showPopulateAutomaticTagsPopup = value;
        },
        SET_POPULATE_AUTOMATIC_TAGS_GROUP(state, value) {
            state.populateAutomaticTagsGroup = value;
        },
        SET_THEMED_DB_IDS(state, value) {
            state.themedDbIds = value;
        },
        SET_TAGS_ACTIVITIES(state, value) {
            state.tagsActivities = value;
        },
        SET_AMIS_SEARCH_TEXT(state, value) {
            state.amisSearchText = value;
        },
        SET_LAST_AMIS_ADVANCED_FETCH_DATE(state, value) {
            state.lastAMISAdvancedFetchDate = value;
        },
        SET_TAG_DYNAMIC_GRAPH(state, value) {
            state.tagDynamicGraphs = value;
        },
        SET_DOCUMENTS_PANEL_CALLBACK(state, value) {
            state.documentsPanelCallback = value;
        },
        SET_FILTERED_TAGS(state, value) {
            state.filteredTags = value;
        },
        SET_INSPECTION_TAG_TREE(state, value){
            state.inspectionTagTree = value;
        },
        SET_SELECTED_INSPECTION_TREE_TAG(state, value){
            state.selectedInspectionTreeTag = value;
        },
        SET_INSPECTION_TREE_FILTER_CHANGED(state, value) {
            state.inspectionTreeFilterChanged = value;
        },
        SET_SHOW_TAG_MASTER_RESULT(state, value){
            state.showTagMasterResult = value;
        },
        SET_HARVESTED_NODES_IDS(state, value){
            state.harvestedNodesIds = value;
        },
        SET_HARVESTERS(state, value){
            state.harvesters = value;
        },
        SET_GET_BASE_TAGS_TIMEOUT(state, value){
            state.getBaseTagsTimeout = value;
        },
        SET_INSPECTION_MASTER_TYPE_OPTIONS(state, value){
            state.inspectionMasterTypeOptions = value;
        },
        SET_IS_EQUIPMENT_MASTER_AVAILABLE(state, value){
            state.isEquipmentMasterAvailable = value;
        },
        SET_IS_PIPELINE_MASTER_AVAILABLE(state, value){
            state.isPipelineMasterAvailable = value;
        },
        SET_IS_STRUCTURAL_MASTER_AVAILABLE(state, value){
            state.isStructuralMasterAvailable = value;
        },
        SET_IS_INSPECTION_TREE_OPTION(state, value){
            state.isInspectionTreeOption = value;
        },
    },

    actions: {
        ADD_TAG_TO_PREVIOUS_TAGS({ dispatch, commit, state }, { tag }) {
            state.previousTags = [...state.previousTags, tag];
        },
        POP_TAG_FROM_PREVIOUS_TAGS({ dispatch, commit, state }) {
            if (!state.previousTags.length) return;

            let tag = state.previousTags.pop();

            dispatch('OPEN_TAG', { tag: tag.clone() });
        },
        CLEAR_PREVIOUS_TAGS({ dispatch, commit, state }) {
            state.previousTags = [];
        },
        FETCH_ADMIN_AUTOMATIC_TAGS({ dispatch, commit, state, getters }, { assetId, reload = true, index = 0, range = 25, searchText = '' }) {
            return new Promise((resolve, reject) => {
                let text = searchText ? btoa(searchText) : '';
                HttpService.get({
                    url: `api/equipments/fetchAdminAutomaticEquipments`,
                    params: {
                        assetId: assetId,
                        index: index,
                        range: range,
                        searchText64: text
                    }
                }).then(response => {
                    if (reload) commit("SET_AUTOMATIC_TAGS", []);
                    let tags = response.data.map(o => Object.assign(new ForgeEquipment(), o));
                    tags.forEach(o => o.parseContent());
                    commit("SET_AUTOMATIC_TAGS", getters['GET_AUTOMATIC_TAGS'].concat(tags));
                    resolve();
                }).catch(error => {
                    console.error(error);
                    reject(error);
                });
            })
        },
        FETCH_ALL_STRUCTURAL_TAGS_INFO({ dispatch, commit, state }, { assetId }) {
            return new Promise((resolve, reject) => {
                try {
                    HttpService.get({
                        url: `api/tags/structural/getAllTagsMinimalInfo`,
                        params: {
                            assetId: assetId
                        }
                    }).then(({ data }) => {
                        let shortInfo = data.map(o => {
                            let obj = Object.assign(new ForgeTagShortInfo('Structural'), o);
                            obj.parseContent();
                            return obj;
                        });
                        commit('SET_ALL_EXISTING_STRUCTURAL_TAGS', shortInfo);
                    }).catch(error => console.error(error.message));
                } catch (error) {
                    console.error(error);
                    reject(error);
                }
            })
        },
        FETCH_ALL_PIPELINES_TAGS_INFO({ dispatch, commit, state }, { assetId }) {
            return new Promise((resolve, reject) => {
                try {
                    HttpService.get({
                        url: `api/tags/pipeline/getAllTagsMinimalInfo`,
                        params: {
                            assetId: assetId
                        }
                    }).then(({ data }) => {
                        let shortInfo = data.map(o => {
                            let obj = Object.assign(new ForgeTagShortInfo('Pipeline'), o);
                            obj.parseContent();
                            return obj;
                        });
                        commit('SET_ALL_EXISTING_PIPELINES_TAGS', shortInfo);
                    }).catch(error => console.error(error.message));
                } catch (error) {
                    console.error(error);
                    reject(error);
                }
            })
        },
        fetchAllAutomaticTagsDbids({ dispatch, commit, state }, { assetId, callback }) {
            if (state.allExistingAutomaticDbids.length > 0) {
                if (callback)
                    callback();
                return;
            }
            forgeFetch(`api/equipments/getAllAutomaticTagsDbids?assetId=${assetId}`, allDbids => {
                state.allExistingAutomaticDbids = allDbids.map(o => {
                    let t = Object.assign(new ForgeTagShortInfo(), o);
                    t.parseContent();
                    return t;
                });

                if (callback) callback();
            })
        },
        fetchAllAMISColors({ dispatch, commit, state }) {
            forgeFetch(`api/Mods/GetLifeColorOption`, opts => {
                state.InspectionRemainingLifeColorOptions = opts?.data
            })
            forgeFetch(`api/Mods/GetCorrosionColorOption`, opts => {
                state.InspectionCorrRateColorOptions = opts?.data
            })
            forgeFetch(`api/Mods/GetThickPlanColorOption`, opts => {
                state.InspectionThickPlanColorOptions = opts?.data
            })
        },
        PUSH_TAGS_TO_AUTOMATIC_TAGS({ dispatch, commit, state }, { tags }) {
            if (tags.length < 1) return;

            let acceptedTags = tags.reduce((collection, item) => {
                if (!state.automaticTags.find(t => t.id == item.id)) {
                    collection.push(item)
                }
                return collection;
            }, [])

            state.automaticTags = [...state.automaticTags, ...acceptedTags];

            acceptedTags = acceptedTags.filter(t => t.children).map(t => t.children[0].dbId);
            state.filteredAutomaticTagsIds = [...state.filteredAutomaticTagsIds, ...acceptedTags];
        },
        PUSH_TAGS_TO_STRUCTURAL_TAGS({ dispatch, commit, state }, { tags }) {
            if (tags.length < 1) return;

            let acceptedTags = tags.reduce((collection, item) => {
                if (!state.structuralTags.find(t => t.id == item.id)) {
                    collection.push(item)
                }
                return collection;
            }, [])

            state.structuralTags = [...state.structuralTags, ...acceptedTags];

            acceptedTags = acceptedTags.filter(t => t.children).map(t => t.children[0].dbId);
            state.filteredStructuralTagsIds = [...state.filteredStructuralTagsIds, ...acceptedTags];
        },
        PUSH_TAGS_TO_PIPELINES_TAGS({ dispatch, commit, state }, { tags }) {
            if (tags.length < 1) return;

            let acceptedTags = tags.reduce((collection, item) => {
                if (!state.pipelinesTags.find(t => t.id == item.id)) {
                    collection.push(item)
                }
                return collection;
            }, [])

            state.pipelinesTags = [...state.pipelinesTags, ...acceptedTags];

            acceptedTags = acceptedTags.filter(t => t.children).map(t => t.children[0].dbId);
            state.filteredPipelineTagsIds = [...state.filteredPipelineTagsIds, ...acceptedTags];
        },
        getAutomaticTagTagById({ dispatch, commit, state }, id) {
            return new Promise((resolve, reject) => {
                try {
                    forgeFetch(`api/equipments/getAutomaticTagById?id=${id}`, autoTag => {
                        if (autoTag) {
                            autoTag = Object.assign(new ForgeEquipment(), autoTag)
                            autoTag.parseContent()
                            resolve(autoTag);
                        }
                    })
                } catch (error) {
                    console.log(error);
                    reject(error);
                }
            })
        },
        fetchAllAMISTagsDbids({ dispatch, commit, state }, { assetId, callback }) {
            forgeFetch(`api/AMIS/getAllAMISDbids?assetId=${assetId}`, allDbids => {
                state.allExistingAMISDbids = allDbids
                allDbids.forEach(o => {
                    o.dbid = o.children.length > 0 ? o.children[0].dbId : null
                    o.point = o.point ? Object.assign(new THREE.Vector3(), o.point) : null;
                    o.type = 'Inspection';
                });
                dispatch('UPDATE_AVAILABLE_FILTERS_COLORS');
                if (callback)
                    callback();
            })
        },
        getInspectionsToCapture({ dispatch, commit, state }, { assetId, callback }) {
            forgeFetch(`api/forge/inspections/getInspectionsToCapture?assetId=${assetId}`, allDbids => {
                allDbids.forEach(o => o.dbid = o.children.length > 0 ? o.children[0].dbId : null);
                state.inspectionDbIdsToCapture = allDbids
                if (callback)
                    callback();
            })
        },
        GET_HARVESTER_TAGS_NEEDS_IMAGES_IDS({ dispatch, commit, state }, { harvestersIds }) {
            return new Promise((resolve, reject) => {
                try {
                    HttpService.post({
                        url: `api/harvester/getTagsNeedsImagesIds`,
                        data: {
                            ids: harvestersIds
                        }
                    }).then(({ data }) => {
                        console.log(data)
                        resolve(data);
                    }).catch(error => {
                        console.error(error);
                        reject(error);
                    });
                } catch (error) {
                    console.log(error);
                    reject(error);
                }
            });
        },
        GET_AUTOMATIC_TAGS_NEED_IMAGES_IDS_BY_GROUP({ dispatch, commit, state }, { groupInfo, callback }) {
            let data = {
                'assetId': store.state.assetId,
                'harvesterId': groupInfo,
            }

            postDataAsync('api/equipments/getAutomaticTagsNeedsImagesIdsByGroup', data, res => {
                commit("SET_SELECTED_AUTOMATIC_TAGS_GROUP", res);
                if (callback) callback(res);
            });
        },
        LOAD_AMIS_COLORS({ dispatch, commit, state, getters }, callback) {
            // Set AMIS colors as default colors and fetch the asset color from the API.
            if (store.state.forgeSettings?.isAMIS || !store.state.forgeSettings?.inspectionFiltersColors) {
                store.state.forgeSettings.inspectionFiltersColors = (new ForgeSettings()).inspectionFiltersColors;
            }

            let colors = store.state.forgeSettings?.getInspectionFiltersColors();


            state.InspectionCorrRateColorOptions.forEach(f => {
                let c = colors.find(o => o.code == f.code && o.symbol == f.judgSymb);
                if (c) {
                    f.judgCor = c.color;
                }
            });

            state.InspectionRemainingLifeColorOptions.forEach(f => {
                let c = colors.find(o => o.code == f.code && o.symbol == f.judgSymb);
                if (c) {
                    f.judgCor = c.color;
                }
            });

            state.InspectionThickPlanColorOptions.forEach(f => {
                let c = colors.find(o => o.code == f.code && o.symbol == f.judgSymb);
                if (c) {
                    f.judgCor = c.color;
                }
            });

            state.InspectionPlanColorOptions.forEach(f => {
                let c = colors.find(o => o.code == f.code && o.symbol == f.judgSymb);
                if (c) {
                    f.judgCor = c.color;
                }
            });

            dispatch('UPDATE_AVAILABLE_FILTERS_COLORS');

            if (callback) callback();

            // Fetch colors from AMIS and save them in the store.
            // getLifeColorOption().then(colors => {
            //     colors.forEach(c => c.judgMkr = c.judgMkr?.trim());

            //     let colorsGroups = groupBy(colors, "code");

            //     for (const [key, value] of Object.entries(colorsGroups)) {
            //         let c = [...value];

            //         if (value[0].judgMkr.includes('>')) c.reverse();

            //         let results = [];

            //         for (let i = 0; i < c.length; i++) {
            //             const item = c[i];
            //             let r = {
            //                 "code": item.code,
            //                 "codeOrdr": item.codeOrdr,
            //                 "judgSymb": item.judgSymb,
            //                 "judgCor": item.judgCor
            //             }

            //             if (item.judgMkr.includes('<')) {
            //                 r = {
            //                     ...r,
            //                     "judgCrr1": item.judgCrr,
            //                     "judgMkr1": item.judgMkr,
            //                     "judgCrr2": i === 0 ? '-∞' : c[i - 1].judgCrr,
            //                     "judgMkr2": '>',
            //                 }
            //             } else {
            //                 r = {
            //                     ...r,
            //                     "judgCrr1": i + 1 === c.length ? '∞' : c[i + 1].judgCrr,
            //                     "judgMkr1": '<',
            //                     "judgCrr2": item.judgCrr,
            //                     "judgMkr2": item.judgMkr,
            //                 }
            //             }
            //             results.push(r)
            //         }

            //         if (value[0].judgMkr.includes('>')) results.reverse();

            //         colorsGroups[key] = results;
            //     }

            //     state.InspectionCorrRateColorOptions = colorsGroups["1"] ?? [];
            //     state.InspectionRemainingLifeColorOptions = colorsGroups["2"] ?? [];
            //     state.InspectionThickPlanColorOptions = colorsGroups["3"] ?? [];

            //     if(callback) callback(colorsGroups);
            // })
        },
        LOAD_AMIS_UNITS({ dispatch, commit, state, getters }, callback) {
            var assetId = getters['getAssetId'];
            forgeFetch(`api/AMIS/getAllAMISUnits?assetId=${assetId}`, units => {
                units = [...new Set(units)]
                units = units.map(o => ({ id: o.pltCode, name: o.pltName, isChecked: false }));
                for (let i = 0; i < 2; i++) {
                    const unit = units[i];
                    if (unit) {
                        unit.isChecked = true;
                    }                    
                }
                commit('SET_AMIS_UNITS', units);
            })
        },
        UPDATE_AVAILABLE_FILTERS_COLORS({ dispatch, commit, state, getters }, callback) {
            var res = [];
            var targetProperty = '';
            let options = [];

            if (state.InspectionSelectedFilter == 'Remaining Thickness') {
                options = state.InspectionThickPlanColorOptions
                targetProperty = 'rt'
            } else if (state.InspectionSelectedFilter == 'Remaining Life') {
                options = state.InspectionRemainingLifeColorOptions
                targetProperty = 'rl'
            } else if (state.InspectionSelectedFilter == 'Corrosion Rate') {
                options = state.InspectionCorrRateColorOptions
                targetProperty = 'cr'
            } else if (state.InspectionSelectedFilter == 'Inspection Plan') {
                options = state.InspectionPlanColorOptions
                targetProperty = 'ispDateDays'
            } else if (state.InspectionSelectedFilter?.includes('Last Inspection')) {
                options = state.LastInspectionColorOptions
                targetProperty = state.InspectionSelectedFilter?.includes('Thickness') ? 'ispDateDays' : 
                                 state.InspectionSelectedFilter?.includes('Visual') ? 'offerLastInspDateDays' : 'nearestLastDateDays'
            } else if (state.InspectionSelectedFilter?.includes('Next Inspection')) {
                options = state.NextInspectionColorOptions
                targetProperty = state.InspectionSelectedFilter?.includes('Thickness') ? 'nIspDateDays' : 
                                 state.InspectionSelectedFilter?.includes('Visual') ? 'offerNextInspDateDays' : 'closestNextDateDays'
            } 

            var allTagsInfo = state.allExistingAMISDbids.concat(getters['getInspections']);
            var units = state.amisUnits;
            var types = getters.GET_INSPECTION_MASTER_TYPE_OPTIONS;
            let unitsIds = units.filter(u => u.isChecked).map(o => o.name);
            let typesIds = types.filter(u => u.isChecked).map(o => o.name);
            let unitNeedCheck = units.some(e => !e.isChecked);
            let typeNeedCheck = types.some(e => !e.isChecked);


            options.forEach(o => {
                var tags = [];

                let j1 = o.judgCrr1?.toString().includes('∞') ? Infinity : o.judgCrr1;
                let j2 = o.judgCrr2?.toString().includes('-∞') ? -Infinity : o.judgCrr2;

                if (o.judgMkr1 == "<" && o.judgMkr2 == '>=') {
                    tags = allTagsInfo.filter(e => e[targetProperty] !== null && (e[targetProperty] < j1) && (e[targetProperty] >= j2))
                } else if (o.judgMkr1 == "<" && o.judgMkr2 == '>') {
                    tags = allTagsInfo.filter(e => e[targetProperty] !== null && (e[targetProperty] < j1) && (e[targetProperty] > j2))
                } else if (o.judgMkr1 == "<=" && o.judgMkr2 == '>') {
                    tags = allTagsInfo.filter(e => e[targetProperty] !== null && (e[targetProperty] <= j1) && (e[targetProperty] > j2))
                } else if (o.judgMkr1 == "<=" && o.judgMkr2 == '>=') {
                    tags = allTagsInfo.filter(e => e[targetProperty] !== null && (e[targetProperty] <= j1) && (e[targetProperty] >= j2))
                } else if (o.judgMkr1 == null && o.judgMkr2 == null) {
                    tags = allTagsInfo.filter(e => e[targetProperty] == null)
                }

                if (unitNeedCheck && typeNeedCheck) {
                    tags = tags.filter(e => unitsIds.includes(e.pltName) && typesIds.includes(e.masterType ?? 'None'));
                } else if (unitNeedCheck) {
                    tags = tags.filter(e => unitsIds.includes(e.pltName));
                } else if (typeNeedCheck) {
                    tags = tags.filter(e => typesIds.includes(e.masterType ?? 'None'));
                }
                
                res.push(({
                    id: `${o.code}-${o.codeOrdr}`,
                    title: o.title,
                    name1: o.judgMkr1 ? (o.judgMkr1.includes('<=') ? '≤' : o.judgMkr1) + ' ' + o.judgCrr1 : "N/A",
                    name2: o.judgMkr2 ? (o.judgMkr2.includes('>=') ? '≥' : o.judgMkr2) + ' ' + o.judgCrr2 : "N/A",
                    judgCor: o.judgCor,
                    judgCrr1: o.judgCrr1,
                    judgMkr1: o.judgMkr1,
                    judgCrr2: o.judgCrr2,
                    judgMkr2: o.judgMkr2,
                    judgSymb: o.judgSymb,
                    tags: tags
                }))
            })

            let ids = state.selectedColorOptions?.map(t => t.id) ?? [];
            state.InspectionAvailableColorOptions = res;
            state.selectedColorOptions = [...state.InspectionAvailableColorOptions.filter(i => ids.includes(i.id))];

            if (callback) callback(res);
        },
        OPEN_TAG({ dispatch, commit, state }, { tag }) {
            if (tag instanceof ForgeInspection) {
                commit('SET_EDITING_AMIS_TAG', tag);
                store.state.forgeService.showEditInspectionUI(tag);
            } else {
                commit('SET_EDITING_TAG', tag);
                store.state.forgeService.showEditTagUI(tag);
            }
        },
        // With any change with units we need to update the unit list and the color filters.
        // Units changes on the inspections updates.
        UPDATE_INSPECTIONS_UNITS({ dispatch, commit, state, getters }) {
            let old = getters['GET_AMIS_UNITS'];

            let units = getters['getInspections'].filter(i => i.pltName).map(i => {
                return { id: i.pltName, name: i.pltName, isChecked: true };
            });

            const objSet = new Set();
            const uniqueUnits = [];

            for (const obj of units) {
                if (!objSet.has(obj.id)) {
                    // To save the old units check value.
                    let checked = old.find(u => u.name == obj.name)?.isChecked ?? true;
                    obj.isChecked = checked;
                    objSet.add(obj.id);
                    uniqueUnits.push(obj);
                }
            }

            commit('SET_AMIS_UNITS', uniqueUnits);

            dispatch('UPDATE_AVAILABLE_FILTERS_COLORS', () => {
                let ids = state.selectedColorOptions.map(t => t.id);
                state.selectedColorOptions = [...state.InspectionAvailableColorOptions.filter(i => ids.includes(i.id))];
            });
        },
        RESET_HARVESTER_INFO({ dispatch, commit, state, getters }) {
            commit('SET_TAG_HARVESTER_INFO', {
                id: 0,
                title: "",
                filterOptions: [],
                markIgnore: false,
                removeSlash: false,
                selectedTreeLevel: "All Tiers",
                matchingCategory: "",
                matchingProperty: ""
            });
        },
        VALIDATE_IGNORED_NODE_IDS({ dispatch, commit, state, getters }, { nodesIds }) {
            console.log(`🔎 Validate ignored nodes`);

            return new Promise((resolve, reject) => {
                HttpService.post({
                    url: 'api/equipment/validateIgnoredIds',
                    data: {
                        "nodesIds": nodesIds,
                        "assetId": store.state.assetId
                    },
                }).then(({ data }) => {
                    console.log(`✅ Validate ignored nodes`);
                    resolve(data);
                }).catch(error => {
                    console.error("❌ Validate ignored nodes: ", error);
                    reject(error);
                });
            })
        },
        VALIDATE_DUPLICATED_NODE_IDS({ dispatch, commit, state, getters }, { nodesIds }) {
            console.log(`🔎 Validate duplicated nodes`);

            return new Promise((resolve, reject) => {
                HttpService.post({
                    url: 'api/equipment/validateDuplicatedIds',
                    data: {
                        "nodesIds": nodesIds,
                        "assetId": store.state.assetId
                    },
                }).then(({ data }) => {
                    console.log(`✅ Validate duplicated nodes`);
                    resolve(data);
                }).catch(error => {
                    console.error("❌ Validate duplicated nodes: ", error);
                    reject(error);
                });
            })
        },
        GET_MASTERS_STATUS({ dispatch, commit, state, getters }) {
            return new Promise((resolve, reject) => {
                let assetId = store.state.assetId;

                HttpService.get({
                    url: `api/harvester/getMastersStatus/${assetId}`,
                }).then(({ data }) => {
                    console.log(`✅ Get masters status`);
                    commit('SET_IS_EQUIPMENT_MASTER_AVAILABLE', !!data?.isEquipmentMasterAvailable);
                    commit('SET_IS_PIPELINE_MASTER_AVAILABLE', !!data?.isPipelineMasterAvailable);
                    commit('SET_IS_STRUCTURAL_MASTER_AVAILABLE', !!data?.isStructuralMasterAvailable);
                    resolve(data);
                }).catch(error => {
                    console.error("❌ Get masters status: ", error);
                    reject(error);
                });
            })
        },
        UPDATE_HARVESTED_NODES_IDS({ dispatch, commit, state, getters }) {
            console.log(`🔎 Update harvested nodes`);

            return new Promise((resolve, reject) => {
                HttpService.get({
                    url: 'api/tags/getHarvestedDbIds',
                    params: {
                        "assetId": store.state.assetId
                    },
                }).then(({ data }) => {
                    console.log(`✅ Update harvested nodes`);

                    commit('SET_HARVESTED_NODES_IDS', new Uint32Array(data));
                    resolve(data);
                }).catch(error => {
                    console.error("❌ Update harvested nodes: ", error);
                    reject(error);
                });
            })
        },
        FETCH_ADMIN_HARVESTERS({ dispatch, commit, state, getters }) {
            HttpService.get({
                url: 'api/harvester/getAssetHarvesters',
                params: {
                    "assetId": store.state.assetId
                },
            }).then(({ data }) => {
                commit('SET_HARVESTERS', data ?? []);
            })
        },
        GET_BASE_TAG_BY_ID({ dispatch, commit, state, getters }, id) {
            return new Promise((resolve, reject) => {
                HttpService.get({
                    url: 'api/tags/getBaseTagById',
                    params: {
                        "id": id
                    },
                }).then(({ data }) => {
                    if (!data) return reject();

                    switch (data.discriminator) {
                        case 'ForgeEquipment':
                            data = Object.assign(new ForgeEquipment(), data);
                            break;
                        case 'ForgeStructural':
                            data = Object.assign(new ForgeStructural(), data);
                            break;
                        case 'ForgePipeline':
                            data = Object.assign(new ForgePipeline(), data);
                            break;
                        case 'ForgeScaffold':
                            data = Object.assign(new ForgeScaffold(), data);
                            break;
                        case 'ForgeAnnotation':
                            data = Object.assign(new ForgeAnnotation(), data);
                            break;
                        case 'ForgeInspection':
                            data = Object.assign(new ForgeInspection(), data);
                            break;
                        default:
                            return reject();
                    }

                    data.parseContent();
                    
                    resolve(data);
                }).catch(error => {
                    console.error("❌ Fetch base tag by id: ", error);
                    reject(error);
                });
            })
        },
        TIME_OUT_GET_BASE_TAGS_BY_IDS({ dispatch, commit, state, getters }, ids) {
            return new Promise((resolve, reject) => {
                let lastTimeout = getters.GET_GET_BASE_TAGS_TIMEOUT;

                if (lastTimeout) clearTimeout(lastTimeout);

                let timeout = setTimeout(() => {
                    resolve(dispatch('GET_BASE_TAGS_BY_IDS', ids));
                }, 200);

                commit('SET_GET_BASE_TAGS_TIMEOUT', timeout);
            });
        },
        GET_BASE_TAGS_BY_IDS({ dispatch, commit, state, getters }, ids) {
            return new Promise((resolve, reject) => {
                HttpService.post({
                    url: 'api/tags/getBaseTagsByIds',
                    data: {
                        ids: ids
                    }
                }).then(({ data }) => {
                    if (!data) return resolve([]);

                    let result = [];
                    let currentTag = null;

                    data.forEach(tag => {
                        switch (tag.discriminator) {
                            case 'ForgeEquipment':
                                currentTag = Object.assign(new ForgeEquipment(), tag);
                                break;
                            case 'ForgeStructural':
                                currentTag = Object.assign(new ForgeStructural(), tag);
                                break;
                            case 'ForgePipeline':
                                currentTag = Object.assign(new ForgePipeline(), tag);
                                break;
                            case 'ForgeScaffold':
                                currentTag = Object.assign(new ForgeScaffold(), tag);
                                break;
                            case 'ForgeAnnotation':
                                currentTag = Object.assign(new ForgeAnnotation(), tag);
                                break;
                            case 'ForgeInspection':
                                currentTag = Object.assign(new ForgeInspection(), tag);
                                break;
                            default:
                        }
    
                        if (currentTag) {
                            currentTag.parseContent();
                            result.push(currentTag);
                        }
                    });
                    resolve(result);
                }).catch(error => {
                    reject(error);
                });
            });
        },
        FETCH_STRUCTURAL_TAG_BY_ID({ dispatch, commit, state, getters }, id) {
            return new Promise((resolve, reject) => {
                HttpService.get({
                    url: 'api/tags/structural/getTagById',
                    params: {
                        "id": id
                    },
                }).then(({ data }) => {
                    let tag = Object.assign(new ForgeStructural(), data);
                    tag.parseContent();
                    store.dispatch('PUSH_TAGS_TO_STRUCTURAL_TAGS', { tags: [tag] });
                    resolve(tag);
                }).catch(error => {
                    console.error("❌ Fetch structural tag by id: ", error);
                    reject(error);
                });
            })
        },
        FETCH_PIPELINE_TAG_BY_ID({ dispatch, commit, state, getters }, id) {
            return new Promise((resolve, reject) => {
                HttpService.get({
                    url: 'api/tags/pipeline/getTagById',
                    params: {
                        "id": id
                    },
                }).then(({ data }) => {
                    let tag = Object.assign(new ForgePipeline(), data);
                    tag.parseContent();
                    store.dispatch('PUSH_TAGS_TO_PIPELINES_TAGS', { tags: [tag] });
                    resolve(tag);
                }).catch(error => {
                    console.error("❌ Fetch pipeline tag by id: ", error);
                    reject(error);
                });
            })
        },
        GET_STRUCTURAL_TAGS_BY_IDS({ dispatch, commit, state, getters }, { ids }) {
            return new Promise((resolve, reject) => {
                HttpService.post({
                    url: 'api/tags/structural/getTagsByIds',
                    data: {
                        "ids": ids,
                        "assetId": store.state.assetId
                    }
                }).then(({ data }) => {
                    let tags = data.map(o => Object.assign(new ForgeStructural(), o));
                    tags.forEach(o => o.parseContent());
                    resolve(tags);
                }).catch(error => {
                    console.error("❌ Fetch structural tags by ids: ", error);
                    reject(error);
                });
            })
        },
        GET_PIPELINES_TAGS_BY_IDS({ dispatch, commit, state, getters }, { ids }) {
            return new Promise((resolve, reject) => {
                HttpService.post({
                    url: 'api/tags/pipeline/getTagsByIds',
                    data: {
                        "ids": ids,
                        "assetId": store.state.assetId
                    }
                }).then(({ data }) => {
                    let tags = data.map(o => Object.assign(new ForgePipeline(), o));
                    tags.forEach(o => o.parseContent());
                    resolve(tags);
                }).catch(error => {
                    console.error("❌ Fetch pipeline tags by ids: ", error);
                    reject(error);
                });
            })
        },
        DELETE_EQUIPMENT_TAGS({ dispatch, commit, state, getters }, { ids }) {
            return new Promise((resolve, reject) => {
                HttpService.post({
                    url: 'api/equipments/deleteEquipment',
                    data: {
                        "tagsGuid": ids,
                        "assetId": store.state.assetId
                    },
                }).then(({ data }) => {
                    resolve(data);
                }).catch(error => {
                    console.error("❌ Delete equipment: ", error);
                    reject(error);
                });
            });
        },
        DELETE_PIPELINE_TAGS({ dispatch, commit, state, getters }, { ids }) {
            return new Promise((resolve, reject) => {
                HttpService.post({
                    url: 'api/tags/pipeline/deletePipelines',
                    data: {
                        "ids": ids,
                        "assetId": store.state.assetId
                    },
                }).then(({ data }) => {
                    resolve(data);
                }).catch(error => {
                    console.error("❌ Delete pipeline: ", error);
                    reject(error);
                });
            });
        },
        DELETE_STRUCTURAL_TAGS({ dispatch, commit, state, getters }, { ids }) {
            return new Promise((resolve, reject) => {
                HttpService.post({
                    url: 'api/tags/structural/deleteStructural',
                    data: {
                        "ids": ids,
                        "assetId": store.state.assetId
                    },
                }).then(({ data }) => {
                    resolve(data);
                }).catch(error => {
                    console.error("❌ Delete structural: ", error);
                    reject(error);
                });
            });
        },
        DELETE_SCAFFOLDS_TAGS({ dispatch, commit, state, getters }, { ids }) {
            return new Promise((resolve, reject) => {
                HttpService.post({
                    url: 'api/scaffolds/deleteScaffolds',
                    data: {
                        "guids": ids,
                        "assetId": store.state.assetId
                    },
                }).then(({ data }) => {
                    resolve(data);
                }).catch(error => {
                    console.error("❌ Delete scaffold: ", error);
                    reject(error);
                });
            });
        },
        DELETE_ANNOTATION_TAGS({ dispatch, commit, state, getters }, { ids }) {
            return new Promise((resolve, reject) => {
                HttpService.post({
                    url: 'api/annotations/deleteAnnotations',
                    data: {
                        "guids": ids,
                        "assetId": store.state.assetId
                    },
                }).then(({ data }) => {
                    resolve(data);
                }).catch(error => {
                    console.error("❌ Delete annotation: ", error);
                    reject(error);
                });
            });

        },
        PUSH_PIPELINE_TAG({ dispatch, commit, state }, { tag }) {
            state.manualPipelinesTags.push(tag);

            state.updateComponentUsingTags = !state.updateComponentUsingTags;
        },
        CREATE_PIPELINE_TAG({ dispatch, commit, state, getters }, { tag, thumbnail }) {

            return new Promise((resolve, reject) => {

                HttpService.post({
                    url: 'api/tags/pipeline/createPipeline',
                    data: {
                        "tag": tag,
                        "Img64": thumbnail,
                        "assetId": store.state.assetId
                    },
                }).then(({ data }) => {

                    tag.id = data.id;

                    tag.thumbnailUrl = data.thumbnailUrl;

                    data.children.forEach(o => {

                        var existingChild = tag.children.find(e => e.dbId == o.dbId);

                        if (existingChild) existingChild.id = o.id;
                    });

                    dispatch('PUSH_PIPELINE_TAG', { tag: tag });

                    resolve(tag);

                }).catch(error => {

                    console.error("❌ Create pipeline: ", error);

                    reject(error);
                });
            });
        },
        PUSH_STRUCTURAL_TAG({ dispatch, commit, state }, { tag }) {
            state.manualStructuralTags.push(tag);

            state.updateComponentUsingTags = !state.updateComponentUsingTags;
        },
        CREATE_STRUCTURAL_TAG({ dispatch, commit, state, getters }, { tag, thumbnail }) {

            return new Promise((resolve, reject) => {

                HttpService.post({
                    url: 'api/tags/structural/createStructural',
                    data: {
                        "tag": tag,
                        "Img64": thumbnail,
                        "assetId": store.state.assetId
                    },
                }).then(({ data }) => {

                    tag.id = data.id;

                    tag.thumbnailUrl = data.thumbnailUrl;

                    data.children.forEach(o => {

                        var existingChild = tag.children.find(e => e.dbId == o.dbId);

                        if (existingChild) existingChild.id = o.id;
                    });

                    dispatch('PUSH_STRUCTURAL_TAG', { tag: tag });

                    resolve(tag);

                }).catch(error => {

                    console.error("❌ Create Structural: ", error);

                    reject(error);
                });
            });
        },
        MARK_EQUIPMENT_AS_ISOLATED({ dispatch, commit, state, getters }, { ids }) {
            return new Promise((resolve, reject) => {
                HttpService.post({
                    url: 'api/tags/equipment/markAsIsolated',
                    data: ids,
                }).then(({ data }) => {
                    resolve(data);
                }).catch(error => {
                    console.error("❌ Mark equipment as isolated: ", error);
                    reject(error);
                });
            });
        }
    },

    getters: {
        GET_EDITING_TAG(state) {
            return state.editingTag;
        },
        GET_ADDING_TAG_INFO(state) {
            return state.addingTagInfo;
        },
        GET_ALL_EXISTING_AUTOMATIC_TAGS(state) {
            return state.allExistingAutomaticDbids
        },
        GET_EDITING_AMIS_TAG(state) {
            return state.editingAMISTag;
        },
        GET_AMIS_TAGS(state) {
            return state.amisTags;
        },
        GET_IS_TAG_READ_ONLY(state) {
            return state.isTagReadOnly;
        },
        GET_IS_AMIS_TAG_READ_ONLY(state) {
            return state.isAMISTagReadOnly;
        },
        GET_PREVIOUS_TAGS(state) {
            return state.previousTags;
        },
        GET_IGNORED_TAGS_IDS(state) {
            return state.ignoredTagsIds;
        },
        GET_MUTABLE_IGNORED_TAGS_IDS(state) {
            return state.mutableIgnoredTagsIds;
        },
        GET_TAG_HARVESTER_INFO(state) {
            return state.tagHarvesterInfo;
        },
        GET_MANUAL_STRUCTURAL_TAGS(state) {
            return state.manualStructuralTags;
        },
        GET_STRUCTURAL_TAGS(state) {
            return state.structuralTags;
        },
        GET_ALL_EXISTING_STRUCTURAL_TAGS(state) {
            return state.allExistingStructuralDbIds;
        },
        GET_STRUCTURAL_TAGS_COUNT(state) {
            return state.structuralTagsCount;
        },
        GET_FILTERED_STRUCTURAL_TAGS_IDS(state) {
            return state.filteredStructuralTagsIds;
        },
        GET_MANUAL_PIPELINES_TAGS(state) {
            return state.manualPipelinesTags;
        },
        GET_PIPELINES_TAGS(state) {
            return state.pipelinesTags;
        },
        GET_ALL_EXISTING_PIPELINES_TAGS(state) {
            return state.allExistingPipelineDbIds;
        },
        GET_PIPELINES_TAGS_COUNT(state) {
            return state.pipelinesTagsCount;
        },
        GET_FILTERED_PIPELINES_TAGS_IDS(state) {
            return state.filteredPipelineTagsIds;
        },
        GET_AUTOMATIC_TAGS(state) {
            return state.automaticTags;
        },
        GET_EXISTING_AUTOMATIC_TAGS_INFO(state) {
            return state.allExistingAutomaticDbids;
        },
        GET_AUTOMATIC_TAGS_COUNT(state) {
            return state.allAutmaticTagsCount;
        },
        GET_AMIS_TAGS_TOTAL_COUNT(state) {
            return state.allAMISTagsCount;
        },
        GET_AMIS_TAGS_SEARCH_COUNT(state) {
            return state.allAMISTagsSearchCount;
        },
        GET_ALL_AMIS_TAGS_IDS(state) {
            return state.allExistingAMISDbids;
        },
        GET_SELECTED_AUTOMATIC_TAGS_GROUP(state) {
            return state.selectedAutomaticTagsGroup;
        },
        GET_FILLING_AUTOMATIC_TAGS_IMAGES(state) {
            return state.fillingAutomaticTagsImages;
        },
        GET_FILLING_HARVESTER_TAGS_THUMBNAILS(state) {
            return state.fillingHarvesterTagsThumbnails;
        },
        GET_HARVESTER_TAGS_TO_CAPTURE(state) {
            return state.harvesterTagsToCapture;
        },
        GET_FILLING_AMIS_TAGS_IMAGES(state) {
            return state.fillingAMISTagsImages;
        },
        GET_FILLING_INSPECTIONS_IMAGES(state) {
            return state.fillingInspectionsImages;
        },
        GET_INSPECTIONS_TO_CAPTURE(state) {
            return state.inspectionDbIdsToCapture;
        },
        GET_LINKED_TAGS_CALLBACK(state) {
            return state.linkedTagsPopupCallback;
        },
        GET_FILTERED_AUTOMATIC_TAGS_IDS(state) {
            return state.filteredAutomaticTagsIds;
        },
        GET_AMIS_UNITS(state) {
            return state.amisUnits
        },
        GET_REQUESTED_IMAGES_IDS(state) {
            return state.requestedImagesId;
        },
        GET_AMIS_TOKEN(state) {
            return state.amisToken;
        },
        GET_ALL_AMIS_FILTERED_INSPECTIONS(state) {
            return state.allAMISFilteredInspections;
        },
        GET_FILTERED_INSPECTIONS(state) {
            return state.filteredInspection;
        },
        GET_SHOW_POPULATE_AUTOMATIC_TAGS_POPUP(state) {
            return state.showPopulateAutomaticTagsPopup;
        },
        GET_POPULATE_AUTOMATIC_TAGS_GROUP(state) {
            return state.populateAutomaticTagsGroup;
        },
        GET_THEMED_DB_IDS(state) {
            return state.themedDbIds;
        },
        GET_TAGS_ACTIVITIES(state) {
            return state.tagsActivities;
        },
        GET_AMIS_SEARCH_TEXT(state) {
            return state.amisSearchText;
        },
        GET_LAST_AMIS_ADVANCED_FETCH_DATE(state) {
            return state.lastAMISAdvancedFetchDate;
        },
        GET_TAG_DYNAMIC_GRAPH(state) {
            return state.tagDynamicGraphs;
        },
        GET_DOCUMENTS_PANEL_CALLBACK(state) {
            return state.documentsPanelCallback;
        },
        GET_FILTERED_TAGS(state) {
            return state.filteredTags;
        },
        GET_INSPECTION_TAG_TREE(state){
            return state.inspectionTagTree;
        },
        GET_INSPECTION_TREE_FILTER_CHANGED(state) {
            return state.inspectionTreeFilterChanged;
        },
        GET_SELECTED_INSPECTION_TREE_TAG(state){
            return state.selectedInspectionTreeTag;
        },
        GET_SELECTED_INSPECTION_PROPERTY_FILTER_INDEX(state) {
            return store.state.TAGS.InspectionFiltersOptions.indexOf(store.state.TAGS.InspectionSelectedFilter) + 1;
        },
        GET_IS_PROPERTY_ALLOW_NULL(state) {
            return !!store.state.TAGS.InspectionSelectedFilter?.includes('Inspection');
        },
        GET_SELECTED_COLORS_OPTIONS(state) {
            return state.selectedColorOptions;
        },
        GET_AVAILABLE_COLORS_OPTIONS(state) {
            return state.InspectionAvailableColorOptions;
        },
        GET_SHOW_TAG_MASTER_RESULT(state){
            return state.showTagMasterResult;
        },
        GET_HARVESTED_NODES_IDS(state) {
            return state.harvestedNodesIds;
        },
        GET_HARVESTERS(state) {
            return state.harvesters;
        },
        GET_GET_BASE_TAGS_TIMEOUT(state) {
            return state.getBaseTagsTimeout;
        },
        GET_INSPECTION_MASTER_TYPE_OPTIONS(state) {
            return state.inspectionMasterTypeOptions;
        },
        GET_IS_EQUIPMENT_MASTER_AVAILABLE(state) {
            return state.isEquipmentMasterAvailable;
        },
        GET_IS_STRUCTURAL_MASTER_AVAILABLE(state) {
            return state.isStructuralMasterAvailable;
        },
        GET_IS_PIPELINE_MASTER_AVAILABLE(state) {
            return state.isPipelineMasterAvailable;
        },
        GET_IS_INSPECTION_TREE_OPTION(state) {
            return state.isInspectionTreeOption;
        },
        GET_TAGS_FROM_TREE(state) {
            function extractTagsRecursively(parent) {
                if (Object.prototype.hasOwnProperty.call(parent, 'checked')) {
                    if (parent.checked) {
                        return parent.children;
                    } else {
                        return [];
                    }
                }

                let tagsInDescendants = [];
                if (parent.children) {
                    parent.children.forEach((child) => {
                        let extracted = extractTagsRecursively(child);
                        for (let childItem of extracted) {
                            tagsInDescendants.push(childItem)
                        }
                    })
                }
                
                return tagsInDescendants;
            }
            return extractTagsRecursively(state.inspectionTagTree);
        }
    },
}